import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../lib/firebase";

export { getHeaderAuthCta, getPassportCta } from "./authCtas";

export const useAuthSession = () => {
  const [state, setState] = useState({ status: "loading", user: auth.currentUser });

  useEffect(() => onAuthStateChanged(auth, (user) => {
    setState({ status: "ready", user });
  }), []);

  return state;
};
